// extracted by mini-css-extract-plugin
module.exports =  {"disabled":"BeVcXrfciXRdHb2U1evg","setting":"kpIRGj8hbJKM6rlAZsQ_"};